import { render, staticRenderFns } from "./PreprojectPage.vue?vue&type=template&id=47537901&"
import script from "./PreprojectPage.vue?vue&type=script&lang=js&"
export * from "./PreprojectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports